<template>
    <el-dialog
        :visible.sync="Visible"
        v-loading="openloading"
        title="请选择要覆盖的门店"
        element-loading-background="rgba(0, 0, 0, 0.1)"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <div style="text-align: center">
            <div style="padding-bottom: 10px">
                <span style="color: red; font-size: 20px"
                    >该操作会将此科目类别下所有科目配置覆盖至目标门店</span
                >
            </div>
            <el-transfer
                style="text-align: left; display: inline-block"
                v-model="storeids"
                filterable
                :props="{ key: 'id', label: 'name' }"
                :titles="['门店列表', '已选择']"
                :format="{
                    noChecked: '${total}',
                    hasChecked: '${checked}/${total}'
                }"
                :data="stores"
            ></el-transfer>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="Visible = false">取 消</el-button>
            <el-button type="primary" @click="save">覆 盖</el-button>
        </span>
    </el-dialog>
</template>

<script>
import pagerBar from '@/views/pager/pagerBar'
import config from '../../common/config'
import SubjectService from '../../services/voucher/SubjectService'
export default {
    components: {
        pagerBar
    },
    data() {
        return {
            startEndRows: '',
            openloading: true,
            Visible: false,
            loading: true,
            detailids: [],
            stores: [],
            storeids: [],
            currentStoreId: '',
            currentSubjectTypeId: ''
        }
    },
    methods: {
        openSelect(
            ids,
            storeListBySameBrandId,
            currentStore,
            currentSubjectType
        ) {
            this.startEndRows = ''
            this.storeids = []
            this.detailids = ids
            this.openloading = false
            this.currentStoreId = currentStore
            this.currentSubjectTypeId = currentSubjectType
            this.stores = storeListBySameBrandId
            this.Visible = true
        },
        save() {
            const _this = this
            _this.openloading = true
            if (_this.storeids.length == 0) {
                _this.$message({
                    type: 'error',
                    message: '请选择参照科目类别'
                })
                _this.openloading = false
                return
            }
            var input = {
                detailIds: _this.detailids,
                storeIds: _this.storeids,
                startStopRows: _this.startEndRows,
                storeId: _this.currentStoreId,
                subjectTypeId: _this.currentSubjectTypeId
            }
            SubjectService.subjectAllCoverage(input)
                .then((r) => {
                    if (r.success) {
                        _this.$notify({
                            title: '成功',
                            message: '覆盖成功，请至目标门店检查科目详情',
                            type: 'success',
                            position: 'bottom-right'
                        })
                    }
                    _this.Visible = false
                    _this.openloading = false
                })
                .catch((e) => {
                    _this.openloading = false
                })
        }
    }
}
</script>

<style></style>
